import {useTranslation} from "react-i18next";
import {useNavigate} from 'react-router';
import {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import {dStr, tStr, splitDate, validDateStr, splitTime, validTimeStr, stateIsValid, toUnixT, STEP_REG, STEP_LOC, STEP_SPEC, FIRST_OBS_STEP, NUM_OBS_STEPS, delOfflineObs} from './Util.js';
import {states, strToState, stateToStr, getBigState} from './StateDialog.js';
import {getShortSpecName, getCityName} from './Trans.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {CITY_ID_FORSSA} from './Util.js';
import BottomBar from './BottomBar.js';
import {monthNames} from './Trans.js';
import {stateList} from './Lists.js';
import ObsAppBar from './AppBar.js';
import AddSpec from './AddSpec.js';
import {blAreaList} from './Bl.js';
import {COMM_OK} from './WsR2.js';
import AddReg from './AddReg.js';
import AddLoc from './AddLoc.js';
import AddObs from './AddObs.js';

const ObsAdd = observer((props) => {
	const stepRefs = [useRef(), useRef(), useRef(), useRef(), useRef()];
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const navigate = useNavigate();
	const specRef = useRef();
	const locRef = useRef();

	const fromRefresh = gStorage.lists.speclist.list ? false : true;

	useEffect(() => {
//		console.log('Add constructor: edit_obs:', gStorage.main.edit_ob.id);

		gStorage.add.setSpec(null);
		gStorage.add.setStartDStr('', false);
		gStorage.add.setStartTStr('', false);
		gStorage.add.setWeather(null);
		gStorage.add.setRegId(0);

		gStorage.add.setObs({
			id: 0,
			lat_obs: 0,
			long_obs: 0,
			lat_tgt: 0,
			long_tgt: 0,
			user_id: gStorage.conn.user.id,
			city_id: 0,
			addr: '',
			start: '',
			end: '',
			tz: 0,
			spec_id: 0,
			twitched: 0,
			eco: 0,
			hidden: gStorage.conn.user.public_obs === 0 ? 1 : 0,
			fin_br_code: 0,
			color1: 0,
			color2: 0,
			uncertainty: 0,
			chk1: 0,
			chk2: 0,
			memo: '',
			subobs: [
				{num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'},
				{num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'},
				{num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'},
				{num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'},
				{num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'},
			]
		});

		if (gStorage.main.edit_obs) {
			if (gStorage.main.edit_obs.id > 0) {
				/* 'Real' obs */
				let msg = {
					sess_id: gStorage.conn.sess_id,
					cmd: 'obs',
					op: 'load',
					data: {
						id: gStorage.main.edit_obs.id,
					},
				}

	//			console.log("Add constructor: load obs:", gStorage.main.edit_obs.id);

				gStorage.conn.ws.send(msg, addRxWs);
				gStorage.main.setEditObs(null);

				gStorage.add.setStep(FIRST_OBS_STEP);
			} else if (gStorage.main.edit_obs.id < 0) {
				/* offline obs */
				let _obs = Object.assign({}, gStorage.add.obs, gStorage.main.edit_obs);

				/* Add missing properties to loaded subobservations */
				for (let i = 0; i < _obs.subobs.length; i++) {
					_obs.subobs[i].state_valid = stateIsValid(_obs.subobs[i].sum_desc, stateList);
					_obs.subobs[i].num_text = _obs.subobs[i].num.toString();
				}

				/* Add missing subobservations */
				while (_obs.subobs.length < NUM_OBS_STEPS)
					_obs.subobs.push({num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'});

				let _d_str = dStr(gStorage.main.edit_obs.start_utc);
				let _d_valid = validDateStr(_d_str);
				
				let _t_str = tStr(gStorage.main.edit_obs.start_utc);
				if (_t_str === '0:00')
					_t_str = '';
				let _t_valid = validTimeStr(_t_str);

				gStorage.add.setStartDStr(_d_str, _d_valid);
				gStorage.add.setStartTStr(_t_str, _t_valid);

				/* ---------------------------------- */

				const city = gStorage.lists.citylist.list.find(x => x.id === _obs.city_id);
				const country = gStorage.lists.countrylist.find(x => x.id === city.country);

				gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === city.country).sort(sortCityList));
				gStorage.add.setCity(city);
				gStorage.add.setCountry(country);

				gStorage.add.setSpec(gStorage.lists.speclist.list.find(x => x.id === _obs.spec_id));

				gStorage.add.setObs(_obs);

				/* ---------------------------------- */

				let a = [];

				_obs.observers.forEach((u_id) => {
					if (addIsAllowedFriend(u_id)) {
						a.push(u_id);
					}
				});

				gStorage.add.setPersonID(a);

				/* ---------------------------------- */

				let t = [];

				_obs.trips.forEach((t_id) => {
					t.push(t_id);
				});

				gStorage.add.setTripID(t);

				gStorage.main.setEditObs(null);
				gStorage.add.setStep(FIRST_OBS_STEP);
			} else {
				console.error('Add constructor, edit_obs with id 0!');
			}
		} else {
			if (fromRefresh)
				return;

			/* apply prev obs */
			let prevObs = JSON.parse(localStorage.getItem('prevObs'));

//			console.log('Add constructor: prevObs:', prevObs);
			const city_id = (prevObs && prevObs.city_id ? prevObs.city_id : CITY_ID_FORSSA);
			const city = gStorage.lists.citylist.list.find(x => x.id === city_id);
			const country = gStorage.lists.countrylist.find(x => x.id === city.country);

			gStorage.add.setCountry(country);
			gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === country.id).sort(sortCityList));

			gStorage.add.setObsCity(city_id);
			gStorage.add.setCity(city);

			if (prevObs) {
				let d_str, d_valid, t_str, t_valid;

				d_str = prevObs.start_d_str;
				d_valid = validDateStr(d_str);
				gStorage.add.setStartDStr(d_str, d_valid);

				t_str = prevObs.start_t_str;
				t_valid = validTimeStr(t_str);
				gStorage.add.setStartTStr(t_str, t_valid);

				gStorage.add.setPos(prevObs.lat_obs, prevObs.long_obs);

				gStorage.add.setAddr(prevObs.addr);
				gStorage.add.setObsUser(gStorage.conn.user.id);

				if (prevObs.observers) {
					gStorage.add.setPersonID(prevObs.observers.filter((p) => addIsAllowedFriend(p)));
				} else {
					gStorage.add.setPersonID([]);
				}

				if (t_valid && t_str.length && d_valid && d_str.length && 
				    gStorage.add.obs.lat_obs && gStorage.add.obs.long_obs && gStorage.conn.online) {
					addAskWeather(gStorage.add.obs.lat_obs, gStorage.add.obs.long_obs, d_str, t_str, gStorage.add.obs.tz);
				}
			} else {
// 				console.log('Add constructor: no previous obs!');
				gStorage.add.setPersonID([]);
			}

			/* Add user to the observer list */
			if (gStorage.add.personID.indexOf(gStorage.conn.user.id) === -1) {
				let a = gStorage.add.personID.slice();

				a.push(gStorage.conn.user.id);
				gStorage.add.setPersonID(a);
			}

			let trips = [];

			if (gStorage.conn.user.trip1)
				trips.push(gStorage.conn.user.trip1);
			if (gStorage.conn.user.trip2)
				trips.push(gStorage.conn.user.trip2);
			if (gStorage.conn.user.trip3)
				trips.push(gStorage.conn.user.trip3);
			gStorage.add.setTripID(trips);

			gStorage.add.setStep(STEP_LOC);
		}

		gStorage.add.setSaveInProg(false);
		gStorage.add.setCityFetchInProg(false);
		gStorage.add.setAddrFetchInProg(false);

		return () => {
			if (gStorage.speechRec.isRecording) {
				console.log('stop recording due to add exit!');
				gStorage.speechRec.recognizer.stop();
			}
		}
		// eslint-disable-next-line
	}, []);

	function addAvailStates(tgt_sa, s) {
		if (s.enabler) {
			let t = typeof(s.enabler);

			if (t === 'function') {
				 if (!s.enabler(gStorage.add.spec)) {
					 return null;
				 }
			} else {
				console.error('stateFilter: unknown disabler type', t);
				return null;
			}
		}

		if (s.substates) {
			return (s.substates.map((ss) => {
					return addAvailStates(tgt_sa, ss);
				}))
		}

		tgt_sa.push(s.disp);
		return null;
	}

	function availStateList(curr_states) {
		let ret = [];
		
		const bs = getBigState(curr_states, states);
		if (bs === '')
			return ret;

		const s = states.find((s) => s.state === bs);

		ret.push(bs);

		s.substates.forEach((ss, ind) => {
			addAvailStates(ret, ss);
		})

		return ret;
	}
	
	function removeInvalidStates() {
		const obs = gStorage.add.obs;

		for (let i = 0; i < obs.subobs.length; i++) {
			if (obs.subobs[i].sum_desc.length) {
				let a = strToState(obs.subobs[i].sum_desc);

				const availStates = availStateList(a);

// 				console.log('availStates', a, availStates);

				for (let i = a.length - 1; i >= 0; i--) {
					if (!availStates.includes(a[i])) {
						a.splice(i, 1);
					}
				}

// 				console.log('a after operation', a);

				const str = stateToStr(a);

// 				console.log('state_check', obs.subobs[i].sum_desc, '=>', str);

				if (obs.subobs[i].sum_desc !== str) {
// 					console.log('setting state of so', i, str);
					gStorage.add.setSOState(i, str, stateIsValid(str, stateList));
				}
			}
		}
	}

	useEffect(() => {
		if (!gStorage.add.spec || !gStorage.add.obs)
			return;

		removeInvalidStates();
		// eslint-disable-next-line
	}, [gStorage.add.spec]);

	function addIsAllowedFriend(id) {
		let user;

		user = gStorage.lists.userlist.list.find((u) => u.id === id);
		if (!user) {
			console.log('addIsAllowedFriend: user', id, 'not found!');
			return false;
		}

		if ((user.id !== gStorage.conn.user.id && user.allow_friend !== 1) || (user.id === 1 && gStorage.conn.user.id !== 1)) {
			console.log('addIsAllowedFriend: user', id, 'not allowed (', user.id, user.allow_friend, ')!');
			return false;
		}

		return true;
	}

	/* ------------------------------------------------------------------ */

	function savePrev() {
		let prevObs = {
			lat_obs:	gStorage.add.obs.lat_obs,
			long_obs:	gStorage.add.obs.long_obs,
			city_id:	gStorage.add.obs.city_id,
			addr:		gStorage.add.obs.addr,
			start_d_str:	gStorage.add.start_d_str,
			start_t_str:	gStorage.add.start_t_valid ? gStorage.add.start_t_str : '',
			observers:	gStorage.add.personID,
		};

		if (gStorage.add.end_d_valid) {
			prevObs.end_d_str = gStorage.add.end_d_str;

			if (gStorage.add.end_t_valid) {
				prevObs.end_t_str = gStorage.add.end_t_str;
			} else {
				prevObs.end_t_str = '';
			}
		} else {
			prevObs.end_d_str = '';
			prevObs.end_t_str = '';
		}

//		console.log('savePrev', prevObs);

		localStorage.setItem('prevObs', JSON.stringify(prevObs));
	}

	function delObs(id) {
		if (id < 0) {
			if (gStorage.conn.online) {
				alert('Attempting to delete offline obs when online!');
				return;
			}

			let ret = delOfflineObs(id);
			if (ret < 0) {
				alert('delOfflineObs failed!');
				return;
			}

			addRxWs(COMM_OK, {cmd: 'obs', op: 'del', result: 'OK'});
		} else {
			if (!gStorage.conn.online) {
				alert('Attempting to delete online obs when offline!');
				return;
			}

			let msg = {
				sess_id: gStorage.conn.sess_id,
				cmd: 'obs',
				op: 'del',
				data: {
					id: id
				}
			}

//			console.log(JSON.stringify(msg));
			gStorage.conn.ws.send(msg, addRxWs);
		}
	}

	function addGetSpecName(spec) {
		let ret = getShortSpecName(spec, gStorage.conn.user);
// 		console.log('addGetSpecName', spec.id, spec.fi, ret);
		return ret;
	}
	
	function addGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function sortCityList(a, b) {
		return addGetCityName(a).localeCompare(addGetCityName(b), 'fi');
	}

	function getheader() {
// 		console.log('getheader: step:', gStorage.add.currentStep);

		if (gStorage.add.currentStep === STEP_REG) {
			return t('add.generic');
		} else if (gStorage.add.currentStep === STEP_LOC) {
			return t('add.loc_and_time');
		} else if (gStorage.add.currentStep === STEP_SPEC) {
			return t('add.species');
		} else if (gStorage.add.currentStep < FIRST_OBS_STEP + NUM_OBS_STEPS) {
			let _so_id = gStorage.add.currentStep - FIRST_OBS_STEP;

			if (gStorage.add.obs.id)
				return addGetSpecName(gStorage.add.spec) + ' ' + (_so_id + 1) + ' / ' + NUM_OBS_STEPS;

			return (_so_id + 1) + ' / ' + NUM_OBS_STEPS;
		}

		return '';
	}

	function addRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('addRxWs: error: ' + status + ', command: ' + msg.cmd + ', ' + msg.op);
			gStorage.add.setOfflineObsInProg(0);
			gStorage.add.setSaveInProg(false);
			return;
		}

// 		console.log('addRxWs: Rx:', msg);

		if (msg.cmd === 'obs') {
			if (msg.op === 'save') {
				gStorage.add.setSaveInProg(false);

				if (msg.result === 'OK') {
					// console.log('Obs succesfully saved! ID:', gStorage.add.obs, msg.data);
					if (gStorage.add.offlineObsInProg) {
						delOfflineObs(gStorage.add.offlineObsInProg);
						gStorage.add.setOfflineObsInProg(0);
					}

					/* Do not save to defaults if We're editing old obs */
					if (!gStorage.add.obs.id)
						savePrev();

					/* b0: V, b1: E, b2: time, b3: region */
					if (msg.data && msg.data.bl && gStorage.conn.user.bl_notification && ((msg.data.bl.mask & 0xd) || msg.data.bl.info.length )) {
						let bln = {
							spec: addGetSpecName(gStorage.add.spec),
							reason_mask: msg.data.bl.mask,
							reason: '', 
							months: [],
							regions: [],
							info: ''
						};

// 						console.log('Bongariliitto', msg.data.bl);

						if (msg.data.bl.mask & 0x01) {
							bln.reason = t('bl.obligation');
						} else {
							let i;

							if (msg.data.bl.mask & 0x04) {
								bln.reason = t('bl.seasonal_rarity');
							} else if (msg.data.bl.mask & 0x08) {
								bln.reason = t('bl.regional_rarity');
							} else {
								bln.reason = t('bl.info');
							}

							for (i = 0; i < monthNames.length; i++) {
								if (msg.data.bl.month_mask & (1 << i)) {
// 									console.log(monthNames[i]);
									bln.months.push(t(monthNames[i]));
								}
							}

							for (i = 0; i < 4; i++) {
								if (msg.data.bl.area_mask & (1 << i)) {
// 									console.log(blAreaList[i].abbr);
									bln.regions.push(t(blAreaList[i].desc));
								}
							}
						}

						bln.info = msg.data.bl.info;

// 						console.log(bln);
						gStorage.conn.setBlNotification(bln);
					}

					if (msg.data && msg.data.pts && msg.data.pts.flags /* && gStorage.conn.user.pts_notification */) {
						gStorage.conn.setPtsNotification(msg.data.pts);
					}

					navigate('/', { replace: true });
				} else {
					console.error('addRxWs: save failed! Result:', msg.result, msg.data.desc);
					alert('addRxWs: save failed! Result: ' + msg.data.desc);
					gStorage.add.setOfflineObsInProg(0);
				}
			} else if (msg.op === 'load') {
				if (msg.result === 'OK') {
// 					console.log('Rx ObsAdd: obs loaded: ', msg.data.obs);

					let _obs = Object.assign({}, gStorage.add.obs, msg.data.obs);

					/* Add missing properties to loaded subobservations */
					for (let i = 0; i < _obs.subobs.length; i++) {
						_obs.subobs[i].state_valid = stateIsValid(_obs.subobs[i].sum_desc, stateList);
						_obs.subobs[i].num_text = _obs.subobs[i].num.toString();
					}

					/* Add missing subobservations */
					while (_obs.subobs.length < NUM_OBS_STEPS)
						_obs.subobs.push({num: 1, sex_id: 1, age_id: 1, plumage_id: 1, acc_id: 1, sum_desc: '', memo: '', state_valid: false, num_text: '1'});

					let _d_str = dStr(msg.data.obs.start_t);
					let _d_valid = validDateStr(_d_str);
					
					let _t_str = tStr(msg.data.obs.start_t);
					if (_t_str === '0:00')
						_t_str = '';
					let _t_valid = validTimeStr(_t_str);

					gStorage.add.setStartDStr(_d_str, _d_valid);
					gStorage.add.setStartTStr(_t_str, _t_valid);
					gStorage.add.setSpec(gStorage.lists.speclist.list.find(x => x.id === _obs.spec_id));
				
					const city = gStorage.lists.citylist.list.find(x => x.id === _obs.city_id);
					const country = gStorage.lists.countrylist.find(x => x.id === city.country);

					gStorage.add.setCityList(gStorage.lists.citylist.list.filter(x => x.country === country.id).sort(sortCityList));
					gStorage.add.setCity(city);
					gStorage.add.setCountry(country);

					gStorage.add.setObs(_obs);

					/* ---------------------------------- */

					let a = [];

					_obs.observers.forEach((u_id) => {
						if (addIsAllowedFriend(u_id)) {
							a.push(u_id);
						}
					});

					gStorage.add.setPersonID(a);

					/* ---------------------------------- */

					let t = [];

					_obs.trips.forEach((t_id) => {
						t.push(t_id);
					});

					gStorage.add.setTripID(t);

// 					console.log('addRxWs', _obs.id, _obs.user_id);

					if (_d_valid && _d_str.length && _t_valid && _t_str.length &&
					    _obs.lat_obs && _obs.long_obs && gStorage.conn.online) {
						addAskWeather(_obs.lat_obs, _obs.long_obs, _d_str, _t_str, _obs.tz);
					}
				} else {
					console.error('addRxWs: load failed ' + msg.data.desc + '!');
					alert('addRxWs: load failed! Result: ', msg.result, msg.data.desc);
				}
			} else if (msg.op === 'del') {
				if (msg.result !== 'OK') {
					console.error('addRxWs: delete failed ' + msg.data.desc + '!');
					alert(t('add.delete_failed') + ': ' + msg.data.desc);
				}

				navigate('/', { replace: true });
			} else {
				console.error('addRxWs: unknown obs operation ' + msg.op + '!');
			}
		} else if (msg.cmd === 'weather') {
			if (msg.op === 'get') {
				if (msg.result === 'OK') {
	// 				console.log('Weather get', msg.data);
					gStorage.add.setWeather(msg.data);
				} else {
					console.error('addRxWs: weather query failed ' + msg.data.desc + '!');
					gStorage.add.setWeather(null);
				}
			} else {
				console.error('addRxWs: unknown weather operation', msg.op);
			}
		} else {
			console.error('addRxWs: unknown command', msg.cmd);
		}
	}

	/* ------------------------------------------------------------------ */

	function addAskWeather(lat, long, d_str, t_str, tz) {
// 		console.log('addAskWeather');
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'weather',
			op: 'get',
			data: {
				wess: {
					lat: lat,
					long: long,
// 					time: t_str,
					tz: tz,
				},
			},
		};

		let d = splitDate(d_str);
		if (!d) {
			console.error('addAskWeather: invalid date', d_str);
			return;
		}

		if (t_str && t_str.length) {
			let t = splitTime(t_str);
			if (t) {
				msg.data.wess.time = toUnixT(d[2], d[1], d[0], t[0], t[1]);
			} else {
				msg.data.wess.time = toUnixT(d[2], d[1], d[0], 0, 0);
			}
		} else {
			msg.data.wess.time = toUnixT(d[2], d[1], d[0], 0, 0);
		}

// 		console.log('addAskWeather', d_str, t_str, tz, msg);
		gStorage.conn.ws.send(msg, addRxWs);
	}

	/* ------------------------------------------------------------------ */

	function saveObs() {
		let d = null, t = null;
		let dt;

		gStorage.add.setSaveInProg(true);

		let _obs = JSON.parse(JSON.stringify(gStorage.add.obs));
		let str, i;

// 		console.log('saveObs: coordinates', _obs.lat_obs, _obs.long_obs);

		str = gStorage.add.start_d_str;
		d = splitDate(str);

		if (gStorage.add.start_t_str.length) {
			str += ' ';
			str += gStorage.add.start_t_str;
			t = splitTime(gStorage.add.start_t_str);
		}

		_obs.start = str;

		if (t) {
			dt = new Date(d[2], d[1] - 1, d[0], t[0], t[1]);
			_obs.st_valid = 1;
		} else {
			dt = new Date(d[2], d[1] - 1, d[0]);
			_obs.st_valid = 0;
		}

		_obs.tz = -dt.getTimezoneOffset() * 60;
		_obs.start_utc = dt.getTime() / 1000.0;

		/* ---------------------------------------------------------- */

		str = gStorage.add.end_d_str;
		_obs.et_valid = 0;
		_obs.end_utc = 0;

		if (str.length) {
			t = null;
			d = splitDate(str);

			if (gStorage.add.end_t_str.length) {
				str += ' ';
				str += gStorage.add.end_t_str;
				t = splitTime(gStorage.add.end_t_str);
			}

			if (t) {
				dt = new Date(d[2], d[1] - 1, d[0], t[0], t[1]);
				_obs.et_valid = 1;
			} else {
				dt = new Date(d[2], d[1] - 1, d[0]);
			}

			_obs.end_utc = dt.getTime() / 1000.0;
		}

		_obs.end = str;

		_obs.observers = gStorage.add.personID;
		_obs.trips = gStorage.add.tripID.filter(e => e !== 0);

		/* ---------------------------------------------------------- */

		delete _obs.p_id;
		delete _obs.obs_t;
		delete _obs.sum_desc;
		delete _obs.start_t;
		delete _obs.end_t;
		delete _obs.num;
		delete _obs.sex_id;
		delete _obs.age_id;
		delete _obs.plumage_id;
		delete _obs.city;
		delete _obs.sci;
		delete _obs.abbr;
		delete _obs.spec;
		delete _obs.sex;
		delete _obs.age;
		delete _obs.plumage;
		delete _obs.nick;
		delete _obs.username;
		delete _obs.tags;
		delete _obs.files;

		for (i = NUM_OBS_STEPS - 1; i >= 0; i--) {
			if (!_obs.subobs[i].state_valid || _obs.subobs[i].num <= 0) {
				_obs.subobs.splice(i, 1);
			} else {
				delete _obs.subobs[i].state_valid;
				delete _obs.subobs[i].num_text;
				
				delete _obs.subobs[i].id;
				delete _obs.subobs[i].p_id;
				delete _obs.subobs[i].obs_t;
				delete _obs.subobs[i].lat_obs;
				delete _obs.subobs[i].long_obs;
				delete _obs.subobs[i].city_id;
				delete _obs.subobs[i].addr;
				delete _obs.subobs[i].lat_tgt;
				delete _obs.subobs[i].long_tgt;
				delete _obs.subobs[i].start_t;
				delete _obs.subobs[i].end_t;
				delete _obs.subobs[i].spec_id;
				delete _obs.subobs[i].user_id;
				delete _obs.subobs[i].city;
				delete _obs.subobs[i].sci;
				delete _obs.subobs[i].abbr;
				delete _obs.subobs[i].spec;
				delete _obs.subobs[i].sex;
				delete _obs.subobs[i].age;
				delete _obs.subobs[i].plumage;
				delete _obs.subobs[i].nick;
				delete _obs.subobs[i].username;
				delete _obs.subobs[i].tz;
				delete _obs.subobs[i].twitched;
				delete _obs.subobs[i].eco;
				delete _obs.subobs[i].hidden;
				delete _obs.subobs[i].tags;
			}
		}

		/* Accept id 0 (=new) for off- and online */
		if (gStorage.conn.online) {
			let msg = {
				sess_id: gStorage.conn.sess_id,
				cmd: 'obs',
				op: 'save',
				data: {
					obs: _obs,
				}
			};

			if (_obs.id < 0) {
				gStorage.add.setOfflineObsInProg(_obs.id);
				msg.data.obs.id = 0;
				console.log('save offline obs');
			} 

			gStorage.conn.ws.send(msg, addRxWs);
		} else {
			if (_obs.id > 0) {
				alert('Can\'t save online obs when offline!');
				gStorage.add.setSaveInProg(false);
				return;
			}

			let off_d = window.localStorage.getItem('offline_obs');
			if (off_d) {
				off_d = JSON.parse(off_d);
			} else {
				off_d = [];
			}

			if (_obs.id === 0) {
				let offd_key = -1;

				off_d.forEach((obs, ind) => {
// 					console.log('offline key:', ind, obs.id);
					if (obs.id <= offd_key) {
						offd_key = obs.id - 1;
					}
				});

// 				console.log('    key:', offd_key);

				_obs.id = offd_key;
				off_d.push(_obs);
			} else {
				for (const [ind, obs] of off_d.entries()) {
					if (obs.id === _obs.id) {
// 						console.log('offline obs', _obs.id, 'found at:', ind);
						off_d[ind] = _obs;
						break;
					}
				}
			}

// 			console.log('offline obs:', JSON.stringify(off_d));

			localStorage.setItem('offline_obs', JSON.stringify(off_d));
			addRxWs(COMM_OK, {cmd: 'obs', op: 'save', result: 'OK'});
		}

// 		console.log('SaveObs:', msg);
	}

	function addRecAction(cmd, rec) {
		const step = gStorage.add.currentStep;

		// console.log('addRecAction', step, cmd);

		if (step === STEP_LOC) {
			locRef.current?.addLocRecAction(cmd, rec);
		} else if (step === STEP_SPEC) {
			specRef.current?.addSpecRecAction(cmd, rec);
		} else if (step >= FIRST_OBS_STEP) {
			stepRefs[step - FIRST_OBS_STEP].current?.addObsRecAction(cmd, rec);
		}
	}

	if (fromRefresh) {
		setTimeout(() => {
			navigate('/', { replace: true });
		}, 1);

		return null;
	}

	// console.log('Add from_voice', gStorage.add.from_voice);

	return(
		<div>
			<ObsAppBar getheader={getheader}/>
			<AddReg/>
			<AddLoc	ref={locRef} askWeather={addAskWeather}/>
			<AddSpec ref={specRef}/>
			<AddObs ref={stepRefs[0]} id={0}/>
			<AddObs ref={stepRefs[1]} id={1}/>
			<AddObs ref={stepRefs[2]} id={2}/>
			<AddObs ref={stepRefs[3]} id={3}/>
			<AddObs ref={stepRefs[4]} id={4}/>
			<AddObs ref={stepRefs[5]} id={5}/>
			<BottomBar 
				delObs={delObs} 
				saveObs={saveObs} 
				rec={{action: addRecAction, continuous: gStorage.add.from_voice}}
			/>
		</div>
	);
});

export default ObsAdd;
